<div class="form-title upper-space">
  <div class="form-title-text">
    {{ inputProduct.type | productType : otherProductName }}: Ontwerp
  </div>
</div>

<form>
  <mat-radio-group
    aria-label="Select an option"
    class="d-flex upper-space lower-space"
    name="fileOption"
  >
    <mat-radio-button
      [value]="false"
      [checked]="inputProduct.newDesign === false"
      (change)="fileOptionSelected($event)"
      [disabled]="disabled"
      >Inpress maakt het ontwerp aan
    </mat-radio-button>

    <mat-radio-button
      class="left-space"
      [value]="true"
      [checked]="inputProduct.newDesign === true"
      (change)="fileOptionSelected($event)"
      [disabled]="disabled"
      >De klant levert het ontwerp aan
    </mat-radio-button>
  </mat-radio-group>

  <div>
    <div class="d-flex">
      <mat-form-field class="wide" appearance="outline">
        <textarea
          class="textarea"
          [ngClass]="client ? 'client-textarea' : ''"
          matInput
          placeholder="Omschrijf het ontwerp"
          name="layoutDescription"
          [(ngModel)]="inputProduct.generalExtraInfo"
          [disabled]="disabled"
          (ngModelChange)="updateProduct.emit()"
          cdkTextareaAutosize
        ></textarea>
      </mat-form-field>
    </div>
  </div>

  <product-description
    [inputProject]="inputProject"
    [inputProduct]="inputProduct"
    [client]="client"
    (updateProduct)="updateProduct.emit()"
  ></product-description>

  <div class="upper-space">
    <file-picker
      [inputProduct]="inputProduct"
      [formSection]="'externalDesign'"
      [client]="client"
      [disabled]="disabled"
      [uploadButtonLabel]="'Ontwerp toevoegen'"
      (answer)="fileOptionUpload($event)"
    ></file-picker>
  </div>

  <div *ngIf="displayImmoscoopOption" class="d-flex">
    <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />
    <div class="left-space">
      <yes-no
        [title]="'Mag het Immoscoop logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [extraInstructions]="''"
        [value]="inputProduct.immoscoopLogo"
        [inputText]="''"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="immoscoopLogoChanged($event)"
      ></yes-no>
    </div>
  </div>

  <div *ngIf="displaySpottoOption" class="d-flex">
    <img src="/assets/spotto_banner.png" class="spotto-logo" />
    <div class="left-space">
      <yes-no
        [title]="'Mag het Spotto logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [extraInstructions]="''"
        [value]="inputProduct.spottoLogo"
        [inputText]="''"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="spottoLogoChanged($event)"
      ></yes-no>
    </div>
  </div>
</form>
